"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var a=Object.is||function(e,t){return e===t?e!==0||1/e===1/t:e!==e&&t!==t};exports.sameValue=a;
